import gql from "graphql-tag";

export const hasEmployeePageAccessQuery = gql`
  query hasEmployeePageAccess($id: ID!) {
    user(id: $id) {
      id
      hasEmployeePageAccess
    }
  }
`;
